var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"ma-1",attrs:{"width":"20","height":"20","src":require("@/assets/images/flags/pl.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }